import * as React from "react";
import { DeviceData } from "../models/DeviceData";
import { parseVoting, IMooN, isMooNVotingType, parseMooNVoting } from "./../helpers";

interface Props {
  x: string;
  y: string;
  votingWidth: string;
  votingHeight: string;
  device?: DeviceData;
}

const DeviceVoting = (props: Props) => {

  const voting = props.device && props.device.ptProtectiveFunction && props.device.ptProtectiveFunction.voting || "";
  let isMooN = false;
  let MooNParsed = null as IMooN;
  if (voting) {
    isMooN = isMooNVotingType(voting);
    if (isMooN) {
      MooNParsed = parseMooNVoting(voting);
    }
    else {
      MooNParsed = parseVoting(voting);
    }
  }
  return (
      <div style={{ left: props.x, top: props.y, position: "absolute", pointerEvents: "all" }}>
          {
              props.device && props.device.ptProtectiveFunction && props.device.ptProtectiveFunction.voting !== "" && props.device.ptProtectiveFunction.voting != null ?
                  isMooN ? <div className="MooN-voting-display">{`${MooNParsed.M}oo${MooNParsed.N}`}</div> : <img src={`/HTMLImages/Image/Voting${voting}.jpg`} style={{ width: props.votingWidth, height: props.votingHeight }} />                  
                  :
                  <div style={{backgroundColor:"rgb(0,0,0,0)"}}></div>
          }
    </div>
  );
}

export default DeviceVoting;